var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 5.42a8 8 0 0 0-5.655-2.339c-4.391 0-8.004 3.613-8.004 8.004a8.005 8.005 0 0 0 8.004 8.004c4.391 0 8.004-3.613 8.004-8.004A8 8 0 0 0 17.09 5.42M6.48 16.03a7 7 0 0 1-2.047-4.95c0-3.844 3.163-7.007 7.007-7.007a7.01 7.01 0 0 1 7.007 7.007c0 3.844-3.163 7.007-7.007 7.007-1.86 0-3.646-.74-4.96-2.057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.86 20.63a1.001 1.001 0 1 0 1.41-1.42l-2.83-2.83a1.001 1.001 0 1 0-1.41 1.42z"
  })));
};
export default SvgSearch;